/**
 * @generated SignedSource<<60059fedf81f729a62e2ada72e19d8eb>>
 * @relayHash 73d0fd4ca5a03022c7ea0a5e384510b3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 73d0fd4ca5a03022c7ea0a5e384510b3

import { ConcreteRequest } from 'relay-runtime';
export type StartVideoCallInput = {
  id: string;
  isPatientReachedByEmailAndSms?: boolean | null;
};
export type useCreateVideoCallMutation$variables = {
  input: StartVideoCallInput;
};
export type useCreateVideoCallMutation$data = {
  readonly startVideoCall: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null;
    readonly startVideoCallOutput: {
      readonly roomSid: string;
      readonly sofiaUserToken: string;
    } | null;
  };
};
export type useCreateVideoCallMutation = {
  response: useCreateVideoCallMutation$data;
  variables: useCreateVideoCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartVideoCallPayload",
    "kind": "LinkedField",
    "name": "startVideoCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StartVideoCallOutput",
        "kind": "LinkedField",
        "name": "startVideoCallOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roomSid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sofiaUserToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateVideoCallMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCreateVideoCallMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "73d0fd4ca5a03022c7ea0a5e384510b3",
    "metadata": {},
    "name": "useCreateVideoCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "234543a09be4cb356726e5bc74a3a342";

export default node;
